/**
 * ReviewsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import BackInStockNotificationsContext from './back-in-stock-notifications-context'
import {
  createBackInStockNotifications,
  deleteBackInStockNotifications,
  fetchBackInStockNotifications,
} from './back-in-stock-notifications-api'

export default function ReviewsProvider({ children }) {
  const state = {
    createBackInStockNotifications,
    deleteBackInStockNotifications,
    fetchBackInStockNotifications,
  }
  return (
    <BackInStockNotificationsContext.Provider value={state}>
      {children}
    </BackInStockNotificationsContext.Provider>
  )
}
